import { StepDataForm } from './StepDataForm'
import { StepNavigate } from './StepNavigate'
import { StepSubmit } from './StepSubmit'
import { StepUploadFiles } from './StepUploadFiles'
import { StepUploadTemplate } from './StepUploadTemplate'
import { useStepperStepContext } from './StepperStepContext'
import { StepperStepBody } from './StepperStepBody'

export function StepperStepContent() {
  return <StepRenderer />
}

function StepRenderer() {
  const { action, isActive, contentClassName } = useStepperStepContext()

  if (!isActive) {
    return (
      <div className={contentClassName}>
        <StepperStepBody />
      </div>
    )
  }

  if (action.type === 'data-form') return <StepDataForm />
  if (action.type === 'navigate') return <StepNavigate />
  if (action.type === 'submit') return <StepSubmit />
  if (action.type === 'uploadfiles') return <StepUploadFiles />
  if (action.type === 'uploadtemplate') return <StepUploadTemplate />

  return (
    <div className={contentClassName}>
      <StepperStepBody />
    </div>
  )
}
